// import { logoutUser } from "components/AE/utils/FetchUtils";
import Logger from 'utils/Logger';
import { push } from 'connected-react-router';
// import { logoutUser } from "modules/authed";
import store from 'store';

const { dispatch } = store;

export function handleErrorV2(ex: any, defaultMsg = 'Please try again...', redirectOnError = true) {
    const status = ex.status;
    if (typeof dispatch === 'function') {
        if (status === 401) {
            // dispatch(logoutUser());
            setTimeout(() => window.location.reload());
            return Promise.resolve({
                title: 'Error',
                message: 'Please re-login to try again.',
            });
        }
        if (status === 403) {
            if (redirectOnError) {
                dispatch(push('/forbidden'));
            }
            return Promise.resolve({
                toastType: 'warning',
                title: 'Access Denied',
                message: "You don't seem to have access to this part of the app",
            });
        }
    }
    return handleError(ex, defaultMsg);
}

function handleError(ex: any, defaultMsg = 'Please try again...') {
    return new Promise((resolve) => {
        if (!ex.json) {
            return resolve({ title: 'Error', message: defaultMsg });
        }

        ex.json()
            .then((data: any) => {
                const { message } = data.error || data.message || defaultMsg;
                if (typeof message === 'string') {
                    return resolve({ title: 'Error', message });
                }
                resolve({ title: 'Error', message: defaultMsg });
            })
            .catch((e: any) => {
                resolve({ title: 'Error', message: defaultMsg });
                Logger.logException(e);
            });
    });
}
